export function getUID() {
    const uid = localStorage.getItem("uid_email");
    if(!uid) return null;
    return uid.trim().toLowerCase();
}

export function setUID(uid) {
    const sanitized = uid.trim().toLowerCase();
    localStorage.setItem("uid_email", sanitized);
    return sanitized;
}
